export class TeamMembership {
  constructor(
    public readonly id: string,
    public readonly employeeId: string,
    public readonly teamId: string,
    public readonly startedAt: Date,
    public readonly endedAt: Date|null,
    public readonly reason: string|null,
    public readonly isPaid: boolean = false,
    public readonly isTemporary: boolean = false,
  ) {}

  static fromJson(json: any): TeamMembership {
    return new TeamMembership(
      json['id'],
      json['employee_id'],
      json['team_id'],
      new Date(json['started_at']),
      json['ended_at'] ? new Date(json['ended_at']) : null,
      json['reason'] ?? null,
      json['is_paid'] ?? false,
      json['is_temporary'] ?? false,
    )
  }
}